import { selector } from '@poa/state';
import { filteredData, isAllColumnsSelected } from './payers.selectors';
import moment from 'moment';

const columns = [
  {
    name: 'client',
    label: 'Анкета платящего',
    width: 60,
    sectionId: 'section_1',
    isSelected: true
  },
  {
    name: '@@separator1',
    label: '—',
    isSelected: true
  },
  {
    name: 'accounts',
    label: 'Анкеты, которые читает',
    width: 500,
    style: {
      textAlign: 'center',
      wordWrap: 'break-word'
    },
    sectionId: 'section_2',
    isSelected: true
  },
  {
    name: '@@separator2',
    label: '—',
    isSelected: true
  },
  {
    name: 'total',
    label: 'Всего',
    width: 115,
    sectionId: 'section_3',
    isSelected: true
  },
  {
    name: 'average',
    label: 'Средний платеж',
    width: 115,
    sectionId: 'section_3',
    isSelected: true
  }
];

export const payersInitialState = {
  payers: {
    ui: {
      favorites: []
    },
    data: [],
    selectedPayer: null,
    meta: {
      currentPage: 1,
      pages: 1,
      pageSize: 25,
      isLoading: false,
      hasError: false,
      loaded: false,
      payers: [],
    },
    filters: {
      startDate: moment().utc().subtract(1, 'months')
        .startOf('month')
        .hours(1),
      endDate: moment().utc().subtract(1, 'months')
        .endOf('month')
        .hours(1),
      grouping: {
        selected: null,
        options: []
      },
      filtering: {
        selected: { id: "1", title: "all", value: "all", label: "all" },
        options: [
          { id: "1", title: "all", value: "all", label: "all" },
          { id: "2", title: "gold", value: "gold", label: "gold" },
          { id: "3", title: "silver", value: "silver", label: "silver" },
          { id: "4", title: "bronze", value: "bronze", label: "bronze" },
        ]
      },
      status: {
        selected: null,
        options: []
      },

      columnSettings: {
        currentPresetId: 0,
        availablePresets: [
          {
            id: 0,
            label: 'по умолчанию',
            columnsConfiguration: columns
          }
        ],
        lastSelectedPresetColumns: []
      },
      isDecimal: false,
      search: ''
    },
    selectors: {
      filteredData,
      isAllColumnsSelected,
      selectedPreset: selector(store => {
        return store.payers.filters.columnSettings.availablePresets.find(
          preset => preset.id === store.payers.filters.columnSettings.currentPresetId
        );
      }),
      currentPresetColumnsList: selector(store =>
        store.payers.selectors.selectedPreset.columnsConfiguration.map(column => column.name)
      )
    }
  }
};
